import { render, staticRenderFns } from "./LogoutSection.vue?vue&type=template&id=b3f09bbc&scoped=true&"
import script from "./LogoutSection.vue?vue&type=script&lang=js&"
export * from "./LogoutSection.vue?vue&type=script&lang=js&"
import style0 from "./LogoutSection.vue?vue&type=style&index=0&id=b3f09bbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f09bbc",
  null
  
)

export default component.exports